<is-igx-organization-chart
  title="顧客を配属させる"
  [orgData]="organizationChart"
  [mappingData]="mappingData"
  [mappingDataHub]="mappingDataHub"
  [hubData]="hubData"
  (onReGisterOrganizationChart)="onReGisterOrganizationChart($event)"
></is-igx-organization-chart>
